/* tslint:disable */

declare var Object: any;
export interface EmploymentHistoryInterface {
  "sfdcId"?: string;
  "ts2__Contact__c"?: string;
  "CreatedById"?: string;
  "CurrencyIsoCode"?: string;
  "Name"?: string;
  "LastModifiedById"?: string;
  "ts2__Compensation__c"?: number;
  "ts2__Employer__c"?: string;
  "ts2__Name__c"?: string;
  "ts2__Employment_End_Date__c"?: Date;
  "ts2__Job_Title__c"?: string;
  "ts2__Location__c"?: string;
  "ts2__Parsed__c"?: boolean;
  "ts2__Placed__c"?: boolean;
  "ts2__Responsibilities__c"?: string;
  "ts2__Role__c"?: string;
  "ts2__Salaried__c"?: boolean;
  "ts2__Employment_Start_Date__c"?: Date;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
}

export class EmploymentHistory implements EmploymentHistoryInterface {
  "sfdcId": string;
  "ts2__Contact__c": string;
  "CreatedById": string;
  "CurrencyIsoCode": string;
  "Name": string;
  "LastModifiedById": string;
  "ts2__Compensation__c": number;
  "ts2__Employer__c": string;
  "ts2__Name__c": string;
  "ts2__Employment_End_Date__c": Date;
  "ts2__Job_Title__c": string;
  "ts2__Location__c": string;
  "ts2__Parsed__c": boolean;
  "ts2__Placed__c": boolean;
  "ts2__Responsibilities__c": string;
  "ts2__Role__c": string;
  "ts2__Salaried__c": boolean;
  "ts2__Employment_Start_Date__c": Date;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: EmploymentHistoryInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `EmploymentHistory`.
   */
  public static getModelName() {
    return "EmploymentHistory";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of EmploymentHistory for dynamic purposes.
  **/
  public static factory(data: EmploymentHistoryInterface): EmploymentHistory{
    return new EmploymentHistory(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'EmploymentHistory',
      plural: 'EmploymentHistories',
      path: 'EmploymentHistories',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "ts2__Contact__c": {
          name: 'ts2__Contact__c',
          type: 'string'
        },
        "CreatedById": {
          name: 'CreatedById',
          type: 'string'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "LastModifiedById": {
          name: 'LastModifiedById',
          type: 'string'
        },
        "ts2__Compensation__c": {
          name: 'ts2__Compensation__c',
          type: 'number'
        },
        "ts2__Employer__c": {
          name: 'ts2__Employer__c',
          type: 'string'
        },
        "ts2__Name__c": {
          name: 'ts2__Name__c',
          type: 'string'
        },
        "ts2__Employment_End_Date__c": {
          name: 'ts2__Employment_End_Date__c',
          type: 'Date'
        },
        "ts2__Job_Title__c": {
          name: 'ts2__Job_Title__c',
          type: 'string'
        },
        "ts2__Location__c": {
          name: 'ts2__Location__c',
          type: 'string'
        },
        "ts2__Parsed__c": {
          name: 'ts2__Parsed__c',
          type: 'boolean'
        },
        "ts2__Placed__c": {
          name: 'ts2__Placed__c',
          type: 'boolean'
        },
        "ts2__Responsibilities__c": {
          name: 'ts2__Responsibilities__c',
          type: 'string'
        },
        "ts2__Role__c": {
          name: 'ts2__Role__c',
          type: 'string'
        },
        "ts2__Salaried__c": {
          name: 'ts2__Salaried__c',
          type: 'boolean'
        },
        "ts2__Employment_Start_Date__c": {
          name: 'ts2__Employment_Start_Date__c',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}
